import {Route, Routes} from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Home from './pages/Dashboard/Home';
import Ereen from './pages/Dashboard/Ereen';
import Mng from './pages/Dashboard/Mng';
import Login from './pages/Login';
import Ezendee from './pages/Dashboard/Ezendee';

function App() {
  return (
    <>
        <Routes>
            <Route path='/' element={<Login/>}/>
            <Route path="/dashboard" element={<Dashboard />}>

            <Route index element={<Home/>}/>
              <Route path="ereen" element={<Ereen/>}/>
              <Route path="mng" element={<Mng/>}/>
              <Route path="ezendee" element={<Ezendee/>}/>
            </Route>
        </Routes>

    </>
  );
}

export default App;
